export default {
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading)
  }
}